import api from "../../axiosConfig";

export const addProcedure = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('/procedure/add-procedure', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getProcedure = async (searchKeyword,doctor_id) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/procedure/all-procedure', {
      params: {
        search_keyword: searchKeyword,
        doctor_id:doctor_id
      },
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
    
  }
};

export const updateProcedure = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    id: parseInt(id),
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);
  console.log('ID for update:', id);  
  try {
    const response = await api.post(`/procedure/update-procedure/${id}`, payload
    );
    

    const resData = response?.data;
    console.log('Update receptionist response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
      
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating receptionist');
  }
};
export const deleteProcedure = async (id) => {
  try {
    const response = await api.delete(`procedure/delete/${id}`);

    const resData = response?.data;
    console.log('Delete procedure response:', resData);

    if (resData?.message_type === 'success') {
      return { success: true, data: resData.message };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error deleting medicine');
  }
};